import {
  Avatar,
  Box,
  Grid,
  MenuItem,
  Select,
  Stack,
  Typography,
  TextField,
  CircularProgress,
  Chip,
} from "@mui/material";
import { Form, Formik } from "formik";
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from "react-redux";
import { searchInfluencers, loadAllDictionaryData } from "./action";
import {
  updateUltimateDiscover,
  resetUltimateDiscover,
  setPlatform,
  setSearchKeyword,
  setFilters,
  clearFilters,
  setPage,
} from "./ultimateDiscoverSlice";
import UltimateDiscoverResults from "./UltimateDiscoverResults";
import { useEffect, useState, useRef } from "react";
import SearchIcon from "../../assets/images/icons/searchIcon.svg";
import clearIcon from "../../assets/images/icons/X.svg";
import FilterIcon from "../../assets/images/icons/filterIcon.svg";
import { PLATFORMS_IMGS_LIST, COMPANY } from "../../utils/constant";
import {
  getUserType,
  capitalizeWords,
  DiscoverySearchInfluencerButton,
} from "../../utils/common";
import arrowTopDiagonal from "../../assets/images/icons/arrowTopDiagnoal.svg";
import UltimateNestedDropdown from "./UltimateNestedDropdown";
import { Alert } from "../../utils/Alert";

const useStyles = makeStyles({
  fadeIn: {
    animation: '$fadeIn 1s ease-in-out forwards',
  },
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(4px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
  },
});

const UltimateDiscover = () => {
  const dispatch = useDispatch();
  const { plateforms, niches, userInfo } = useSelector(
    (state) => state.commonSlice,
  );
  const {
    platform,
    searchKeyword,
    filters,
    results,
    page,
    limit,
    showLoading,
    creditsRemaining,
    source,
    aiInfo,
    searchRequestId,
    hasMore,
    totalCount,
  } = useSelector((state) => state.ultimateDiscoverSlice);
  const resultsRef = useRef(null);
  const prevLoadingRef = useRef(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const classes = useStyles();

  const placeHolderValues = ["categories,", "topics,", "bio keywords #anything!"];
  const [placeHolder, setPlaceHolder] = useState("Type here, ✨");

  useEffect(() => {
    let index = 0;
    let base = "Type here,";
    let currentWords = [];
    const startLoop = () => {
      const addNext = () => {
        if (index < placeHolderValues.length) {
          setPlaceHolder(`${base} ${currentWords.join(' ')}`);
          setTimeout(() => {
            const newWord = placeHolderValues[index];
            currentWords.push(newWord);
            setPlaceHolder(
              <>
                {base}
                {' ' + currentWords.slice(0, -1).join(' ') + ' '}
                <span className={classes.fadeIn}>
                  {newWord} ✨
                </span>
              </>
            );
            index++;
            setTimeout(addNext, 1000);
          }, 1000);
        } else {
          setTimeout(() => {
            base = "Type here,";
            index = 0;
            currentWords = [];
            setPlaceHolder(
              <span className={classes.fadeIn}>
                Type here,✨
              </span>
            );
            addNext();
          }, 1000);
        }
      };

      setTimeout(addNext, 1000);
    };
    if (!isFocused && !searchKeyword) {
      startLoop();
      index = 0;
      base = "Type here,";
      currentWords = [];
    }

    return () => {};
  }, [isFocused, searchKeyword]);

  useEffect(() => {
    dispatch(loadAllDictionaryData());
    return () => {
      dispatch(resetUltimateDiscover());
    };
  }, [dispatch]);

  useEffect(() => {
    if (prevLoadingRef.current && !showLoading && results.length > 0) {
      if (resultsRef.current) {
        resultsRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
    prevLoadingRef.current = showLoading;
  }, [showLoading, results.length]);

  const handleSearch = () => {
    const noLocation = !filters.locations || filters.locations.length === 0;
    const noLanguage = !filters.languages || filters.languages.length === 0;

    const errors = [];
      if (noLocation) errors.push("at least one location");
      if (noLanguage) errors.push("at least one language");
      if (errors.length > 0) {
        Alert(2, `Please select ${errors.join(" and ")}`);
        return;
      }
    dispatch(setPage(1));
    dispatch(searchInfluencers(false));
  };

  const handleLoadMore = () => {
    dispatch(setPage(page + 1));
    dispatch(searchInfluencers(true));
  };

  const handlePlatformChange = (value) => {
    dispatch(setPlatform(value));
  };

  const handleSearchKeywordChange = (value) => {
    dispatch(setSearchKeyword(value));
  };

  const handleFilterChange = (key, value) => {
    dispatch(setFilters({ [key]: value }));
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
    dispatch(updateUltimateDiscover({ searchKeyword: "" }));
  };

  const hasActiveFilters = () => {
    return (
      filters.minFollowers ||
      filters.maxFollowers ||
      filters.minEngagement ||
      filters.maxEngagement ||
      filters.gender ||
      filters.locations ||
      filters.isVerified ||
      (filters.categories && filters.categories.length > 0) ||
      (filters.languages && filters.languages.length > 0) ||
      (filters.brands && filters.brands.length > 0) ||
      (filters.audienceInterests && filters.audienceInterests.length > 0) ||
      filters.hasBrandDeals !== null ||
      searchKeyword
    );
  };

  return (
    <Box
      className="ultimate-discover-container"
      sx={{ minHeight: "100vh", pb: 4 }}
    >
      <Formik
        initialValues={{
          platform: platform,
          searchText: searchKeyword,
          gender: filters.gender || "",
        }}
        validateOnChange={true}
        onSubmit={(values) => {
          handleSearch();
        }}
      >
        {({ handleChange, handleSubmit, values, setFieldValue }) => {
          return (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
            >
              <Grid className="campSerchInflu" pt={2} container mb={5}>
                <Grid
                  item
                  className="mx-auto"
                  xs={12}
                  xl={6}
                  lg={8}
                  md={11}
                  sm={12}
                  pt={5}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="h3"
                    fontWeight="bold"
                    sx={{
                      background:
                        "linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textAlign: "center",
                      fontFamily: "var(--family1)",
                      width: "fit-content",
                      paddingBottom: "16px",
                    }}
                  >
                    Hey{" "}
                    {capitalizeWords(
                      getUserType() === COMPANY
                        ? userInfo?.companyName || userInfo?.contactPersonName
                        : userInfo?.adminName,
                    )}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: 400,
                      fontSize: "20px",
                      fontFamily: "var(--family1)",
                      color: "#726C6C",
                    }}
                  >
                    Let Us Help You Find the Right Influencers—Effortlessly!
                  </Typography>
                  <Grid
                    className="mx-auto"
                    item
                    xs={12}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    style={{ width: "100%" }}
                  >
                    <Box className="searchBlockInflu">
                      <Stack
                        direction="row"
                        sx={{
                          padding: "0",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Select
                          className="searchPlatform"
                          name="platform"
                          value={platform}
                          onChange={(e) => {
                            handlePlatformChange(e.target.value);
                            setFieldValue("platform", e.target.value);
                          }}
                          displayEmpty
                          open={openDropdown}
                          onOpen={() => setOpenDropdown(true)}
                          onClose={() => setOpenDropdown(false)}
                          IconComponent={(props) => (
                            <CustomDropdownIcon
                              {...props}
                              open={openDropdown}
                            />
                          )}
                          sx={{
                            minWidth: "fit-content",
                            borderRadius: "8px",
                            background: "white",
                            position: "relative",
                            overflow: "hidden",
                            height: "40px",
                            "& .MuiSelect-select": {
                              padding: "0 0px 0 13px !important",
                              width: "68px",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                              border: "0px solid transparent",
                            },
                            "::before": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              padding: "2px",
                              borderRadius: "8px",
                              background:
                                "linear-gradient(90deg, #FFCC70, #C850C0, #4158D0)",
                              "-webkit-mask":
                                "linear-gradient(white, white) content-box, linear-gradient(white, white)",
                              "-webkit-mask-composite": "destination-out",
                              maskComposite: "exclude",
                              pointerEvents: "none",
                              outline: 0,
                            },
                            "&.Mui-focused, &:hover, &:focus-within,&:focus-visible":
                              {
                                border: "0px solid transparent",
                                "::before": {
                                  opacity: 1,
                                },
                              },
                            padding: "0px",
                            outline: 0,
                          }}
                          renderValue={(selected) => {
                            let normalized = capitalizeWords(selected);
                            if (normalized === "Youtube")
                              normalized = "YouTube";

                            if (normalized === "Both") {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    ml: 1,
                                  }}
                                >
                                  <img
                                    alt="Instagram"
                                    width="22"
                                    height="22"
                                    src={PLATFORMS_IMGS_LIST["Instagram"]}
                                    style={{ position: "relative", zIndex: 2 }}
                                  />
                                  <img
                                    alt="Youtube"
                                    width="22"
                                    height="22"
                                    src={PLATFORMS_IMGS_LIST["Youtube"]}
                                    style={{
                                      position: "relative",
                                      left: "-8px",
                                      zIndex: 1,
                                    }}
                                  />
                                </Box>
                              );
                            }

                            const iconKey =
                              normalized === "YouTube" ? "Youtube" : normalized;
                            const src =
                              PLATFORMS_IMGS_LIST[iconKey] ||
                              PLATFORMS_IMGS_LIST["Instagram"];

                            return (
                              <img
                                alt={normalized || "Instagram"}
                                width="24"
                                height="24"
                                style={{ marginLeft: "6px" }}
                                src={src}
                              />
                            );
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                height: "120px",
                                width: "140px",
                                padding: "0px !important",
                                borderRadius: "12px",
                                boxShadow: "0px 4px 12px 0px #0000001F",
                                mt: 1,
                                "& .MuiMenuItem-root": {
                                  color: "black",
                                },
                              },
                            },
                          }}
                        >
                          {["Instagram", "YouTube", "Both"].map((item) => {
                            const iconKey =
                              item === "YouTube" ? "Youtube" : item;

                            return (
                              <MenuItem
                                key={item}
                                value={item}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  padding: "8px 12px",
                                }}
                              >
                                {item === "Both" ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: 24,
                                      height: 24,
                                    }}
                                  >
                                    <img
                                      alt="Instagram"
                                      width="18"
                                      height="18"
                                      src={PLATFORMS_IMGS_LIST["Instagram"]}
                                      style={{
                                        position: "absolute",
                                        zIndex: 2,
                                      }}
                                    />
                                    <img
                                      alt="Youtube"
                                      width="18"
                                      height="18"
                                      src={PLATFORMS_IMGS_LIST["Youtube"]}
                                      style={{
                                        position: "absolute",
                                        marginLeft: "12px",
                                        zIndex: 1,
                                      }}
                                    />
                                  </Box>
                                ) : (
                                  <Avatar
                                    alt={item}
                                    src={PLATFORMS_IMGS_LIST[iconKey]}
                                    sx={{
                                      width: 24,
                                      height: 24,
                                      overflow: "visible",
                                    }}
                                  />
                                )}
                                <Typography sx={{ ml: 1 }}>{item}</Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>

                        <Box
                          className="searchText"
                          style={{
                            width: "calc(100% - 150px)",
                            paddingLeft: "20px",
                            fontSize: "15px",
                          }}
                        >
                          <TextField
                            name="searchText"
                            value={searchKeyword}
                            variant="outlined"
                            fullWidth
                            onChange={(e) => {
                              handleSearchKeywordChange(e.target.value);
                              setFieldValue("searchText", e.target.value);
                            }}
                            placeholder={isFocused || searchKeyword ? "" : ""}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSearch();
                              }
                            }}
                            InputProps={{
                              startAdornment: !isFocused && !searchKeyword ? (
                                <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                  {placeHolder}
                                </Typography>
                              ) : null,
                              endAdornment: searchKeyword ? (
                                <Box
                                  sx={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    mr: 1,
                                  }}
                                  onClick={() => {
                                    handleSearchKeywordChange("");
                                    setFieldValue("searchText", "");
                                  }}
                                >
                                  <img
                                    src={clearIcon}
                                    alt="clear"
                                    width={16}
                                    height={16}
                                  />
                                </Box>
                              ) : null,
                            }}
                          />
                        </Box>

                        <Box
                          onClick={handleSearch}
                          sx={{
                            zIndex: 999,
                            display: "inline-flex",
                            width: "120px",
                            justifyContent: "flex-end",
                            cursor: showLoading ? "not-allowed" : "pointer",
                            opacity: showLoading ? 0.7 : 1,
                          }}
                        >
                          {showLoading ? (
                            <CircularProgress
                              size={24}
                              sx={{ color: "#C850C0", mr: 2 }}
                            />
                          ) : (
                            <DiscoverySearchInfluencerButton />
                          )}
                        </Box>
                      </Stack>
                      <div
                        className="search-parent-second"
                        style={{ marginTop: "16px" }}
                      >
                        <UltimateNestedDropdown />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>

      {/* {creditsRemaining !== null && (
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Box
            sx={{
              display: 'inline-block',
              background: 'linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)',
              color: 'white',
              fontWeight: 600,
              px: 3,
              py: 1,
              borderRadius: '20px'
            }}
          >
            Credits Remaining: {creditsRemaining}
          </Box>
        </Box>
      )} */}

      <Box
        ref={resultsRef}
        className="ultimate-discover-results-section"
        sx={{ position: "relative" }}
      >
        <Box>
          {results.length > 0 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}
            >
              <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: "wrap" }}>
                <Typography variant="h6" fontWeight={600}>
                  {Math.max(totalCount || 0, results.length)}
                  {hasMore ? "+" : ""} Results Found
                </Typography>
                {source === "local" && (
                  <Chip
                    size="small"
                    label="✨ AI / Local Cache"
                    sx={{
                      backgroundColor: "#E8F5E9",
                      color: "#2E7D32",
                      fontWeight: 600,
                    }}
                  />
                )}
                {source === "api" && (
                  <Chip
                    size="small"
                    label="🌐 Live · Influencers Club"
                    sx={{
                      backgroundColor: "#FFF3E0",
                      color: "#E65100",
                      fontWeight: 600,
                    }}
                  />
                )}
              </Stack>
              {aiInfo?.used && aiInfo?.latencyMs != null && (
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  AI {aiInfo.latencyMs}ms · ${(aiInfo.costUsd || 0).toFixed(5)}
                </Typography>
              )}
            </Stack>
          )}

          {results.length > 0 ? (
            <UltimateDiscoverResults results={results} platform={platform} />
          ) : !showLoading && page === 1 ? (
            <Box sx={{ height: "100vh", marginTop: "60px" }}>
              {searchRequestId && (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography color="text.secondary">
                    No influencers found for your search. Try different keywords or a broader term.
                  </Typography>
                </Box>
              )}
              {/* <Stack>
                <ul className="search-suggestion-list">
                  <li className="search-suggestion-item">
                    <Typography className="search-suggestion-text">List of 10 Travel Influencers 🎒</Typography>
                    <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                  </li>
                  <li className="search-suggestion-item">
                    <Typography className="search-suggestion-text">Top Food Instagrammers in Delhi 🍝</Typography>
                    <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                  </li>
                </ul>

                <ul className="search-suggestion-list">
                  <li className="search-suggestion-item">
                    <Typography className="search-suggestion-text">Food influencers with fitness followers 💪</Typography>
                    <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                  </li>
                  <li className="search-suggestion-item">
                    <Typography className="search-suggestion-text">Top Finance and Business Youtubers 💰</Typography>
                    <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                  </li>
                </ul>
              </Stack> */}
            </Box>
          ) : null}

          {results.length > 0 && hasMore && (
            <Box sx={{ textAlign: "center", mt: 3 }}>
              <Box
                onClick={handleLoadMore}
                disabled={showLoading}
                sx={{
                  display: "inline-block",
                  px: 4,
                  py: 1.5,
                  border: "1px solid #C850C0",
                  borderRadius: "8px",
                  color: "#C850C0",
                  cursor: showLoading ? "not-allowed" : "pointer",
                  fontWeight: 600,
                  opacity: showLoading ? 0.7 : 1,
                  "&:hover": {
                    background: "rgba(200, 80, 192, 0.1)",
                  },
                }}
              >
                {showLoading ? "Loading..." : "Load More"}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UltimateDiscover;

const CustomDropdownIcon = ({ open, ...props }) => {
  return (
    <div {...props} style={{ padding: "0", marginRight: "10px" }}>
      <svg
        style={{
          transition: "transform 0.3s ease",
          border: "0px solid red",
          padding: "0",
          margin: "0",
          height: "14px",
          width: "14px",
          transform: open ? "rotate(0deg)" : "rotate(180deg)",
        }}
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 6L6 1"
          stroke="#AAAAAA"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 1L1 6"
          stroke="#AAAAAA"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
